import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, FileSpreadsheet, BarChart3, Zap, Flame, AlertTriangle, Droplets, Ruler, FileCheck, ChevronDown } from 'lucide-react';

const serviceLinks = [
  { href: '/services', label: 'DPE – Diagnostic de Performance Énergétique', icon: FileSpreadsheet },
  { href: '/audit-energetique', label: 'Audit Énergétique (classes E, F, G)', icon: BarChart3 },
  { href: '/services', label: 'Diagnostic Électricité', icon: Zap },
  { href: '/services', label: 'Diagnostic Gaz', icon: Flame },
  { href: '/services', label: 'Diagnostic Amiante', icon: AlertTriangle },
  { href: '/services', label: 'Diagnostic Plomb (CREP)', icon: Droplets },
  { href: '/services', label: 'Loi Carrez – Mesurage Vente', icon: Ruler },
  { href: '/services', label: 'Loi Boutin – Mesurage Location', icon: Ruler },
  { href: '/services', label: 'État des Risques et Pollutions (ERP)', icon: FileCheck },
];

const localLinks = [
  { href: '/diagnostic-valence-drome', label: 'Diagnostic immobilier Valence Drôme' },
  { href: '/diagnostic-ardeche-saint-peray', label: 'Diagnostic immobilier Ardèche – Saint-Péray' },
  { href: '/diagnostic-orange-vaucluse', label: 'Diagnostic immobilier Orange Vaucluse' },
  { href: '/diagnostic-avignon-region', label: 'Diagnostic immobilier Avignon et région' },
];

const InternalLinks = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-4">
        {/* Discrete accordion trigger */}
        <button
          onClick={() => setOpen((v) => !v)}
          className="w-full flex items-center justify-center gap-2 py-4 text-sm font-medium text-gray-500 hover:text-dk-blue transition-colors"
          aria-expanded={open}
        >
          <span>Liens &amp; zones d'intervention</span>
          <ChevronDown
            className={`h-4 w-4 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
          />
        </button>

        {/* Collapsible content */}
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${
            open ? 'max-h-[2000px] opacity-100 pb-8' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

            {/* Services */}
            <div>
              <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">
                Nos diagnostics immobiliers
              </h2>
              <ul className="space-y-2">
                {serviceLinks.map(({ href, label, icon: Icon }) => (
                  <li key={label}>
                    <Link
                      to={href}
                      className="flex items-center text-sm text-gray-600 hover:text-dk-blue transition-colors group"
                    >
                      <Icon className="h-3.5 w-3.5 mr-2 text-gray-400 group-hover:text-dk-blue flex-shrink-0" />
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Zones géographiques + Infos */}
            <div>
              <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">
                Zones d&apos;intervention
              </h2>
              <ul className="space-y-2">
                {localLinks.map(({ href, label }) => (
                  <li key={label}>
                    <Link
                      to={href}
                      className="flex items-center text-sm text-gray-600 hover:text-dk-blue transition-colors group"
                    >
                      <MapPin className="h-3.5 w-3.5 mr-2 text-gray-400 group-hover:text-dk-blue flex-shrink-0" />
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>

              <div className="mt-6 pt-4 border-t border-gray-200">
                <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">
                  Informations
                </h2>
                <ul className="space-y-2">
                  <li>
                    <Link to="/realisations" className="text-sm text-gray-600 hover:text-dk-blue transition-colors">
                      Nos réalisations
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-sm text-gray-600 hover:text-dk-blue transition-colors">
                      Demander un devis gratuit
                    </Link>
                  </li>
                  <li>
                    <Link to="/mentions-legales" className="text-sm text-gray-600 hover:text-dk-blue transition-colors">
                      Mentions légales
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <p className="mt-6 text-xs text-gray-400 text-center">
            DIAGNOSTI-K SARL – 95 avenue Fernand Gonnet, 84850 Camaret-sur-Aigues –{' '}
            <a href="tel:0789307500" className="hover:text-dk-blue transition-colors">07 89 30 75 00</a>
            {' '}– Vaucluse (84), Drôme (26), Gard (30), Bouches-du-Rhône (13)
          </p>
        </div>
      </div>
    </section>
  );
};

export default InternalLinks;
